import AuthService from "../../utilities/services/auth.service";
import { SalesSummaryWrapper } from "../../components";

export default function SalesSummaryPage() {
  const organization = AuthService.getOrg()[0];

  return <SalesSummaryWrapper organization={organization} />;
}
